import axios from 'Src/helpers/api/axiosInstance';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_FILTER } from '../admin/user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../consts/table';
import { Count } from '../../../models/count';

export function getTournamentNotifications(user: AppUser, tournamentId: string, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/schoolNotifications`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllTournamentNotifications(user: AppUser, tournamentId: string, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/schoolNotifications`, config)
    .then(response => {
      return response.data;
    });
}

export function getTournamentNotificationsCount(user: AppUser, tournamentId: string, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where
        }
      }
    };
  } else {
    config = {
      headers: { usid: key }
    };
  }

  return axios
    .get<Count>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/schoolNotifications/count`,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function getTournamentNotificationsPage(user: AppUser, tournamentId: string, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/schoolNotifications/page`, {
      headers: { usid: key },
      params: { filter }
    })
    .then(response => response.data as { items: any[]; count: number });
}

export function getTournamentNotificationCampaignsPage(user: AppUser, tournamentId: string, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/notificationCampaigns/page`, {
      headers: { usid: key },
      params: { filter }
    })
    .then(response => response.data);
}

export function getTournamentNotificationCampaignNotificationsPage(
  user: AppUser,
  tournamentId: string,
  actionDescriptorId: string,
  filter = DEFAULT_FILTER
) {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .get(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournament/${tournamentId}/notificationCampaigns/${actionDescriptorId}/page`,
      { headers: { usid: key }, params: { filter } }
    )
    .then(response => response.data as { items: any[]; count: number });
}

